import React from 'react';
import { useNavigate } from 'react-router-dom';

const FAQ = [
  {
    title: 'Como encontrar comércios e serviços',
    body: 'Na aba Mapa, escolha sua cidade e navegue pelos marcadores. Use a busca para procurar por nome ou palavra-chave, e os filtros de categoria para refinar. Toque em um comércio para ver detalhes, horários, avaliações, WhatsApp e rotas.',
  },
  {
    title: 'Como funciona o feed',
    body: 'O feed reúne publicações da sua cidade: promoções, eventos, avisos, novidades, empregos e achados. Filtre por tipo para ver só o que interessa.',
  },
  {
    title: 'Como solicitar uma entrega',
    body: 'Entre na aba Entregas, escolha um entregador disponível e toque nele para selecionar. Preencha o endereço de entrega (e o de retirada, se houver) e envie a solicitação. Acompanhe o status em "Meus pedidos" no perfil. O valor é combinado com o entregador.',
  },
  {
    title: 'Como me tornar um entregador',
    body: 'No perfil, toque em "Perfil de entregador" e crie seu perfil informando cidade, veículo, taxa base e raio de atendimento. Depois é só ativar a disponibilidade para aparecer para quem procura entrega na sua cidade.',
  },
  {
    title: 'Como cadastrar meu comércio',
    body: 'No perfil, toque em "Cadastrar comércio" e preencha os dados do estabelecimento. A solicitação fica pendente e é analisada pela equipe da OthoSystems. Depois de aprovado, seu comércio aparece para toda a cidade.',
  },
  {
    title: 'Minha conta e privacidade',
    body: 'Em "Minha conta" você gerencia seus dados, sessões e pode exportar ou excluir sua conta. Nossa Política de Privacidade, Termos de Uso e os seus direitos pela LGPD estão disponíveis nas páginas próprias.',
  },
  {
    title: 'Precisa de mais ajuda?',
    body: 'Use o canal de contato e suporte da OthoSystems na página de Contato. Respondemos em até 5 dias úteis.',
  },
];

export function HelpPage() {
  const navigate = useNavigate();

  return (
    <div className="nc-page nc-page--pad">
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'var(--nc-surface)', borderBottom: '1px solid var(--nc-border)', padding: '12px 16px',
        display: 'flex', alignItems: 'center', gap: 12
      }}>
        <button
          onClick={() => navigate(-1)}
          aria-label="Voltar"
          style={{ background: 'none', border: 'none', padding: 4, cursor: 'pointer', display: 'flex' }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1f2937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 style={{ fontSize: 16, fontWeight: 600, color: 'var(--nc-text)', margin: 0 }}>Ajuda</h1>
      </div>

      <div style={{ padding: '20px 16px', maxWidth: 640, margin: '0 auto' }}>
        {FAQ.map((item, i) => (
          <div key={i} style={{ marginBottom: 24 }}>
            <h2 style={{ fontSize: 15, fontWeight: 600, color: 'var(--nc-primary)', marginBottom: 6 }}>{item.title}</h2>
            <p style={{ fontSize: 14, color: 'var(--nc-text-dim)', lineHeight: 1.7, margin: 0 }}>{item.body}</p>
          </div>
        ))}

        <div style={{
          marginTop: 32, padding: 16, background: 'var(--nc-success-soft)', borderRadius: 10,
          border: '1px solid var(--nc-success-border)', fontSize: 12, color: '#166534', lineHeight: 1.6
        }}>
          <strong>Links úteis:</strong>
          <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <a href="/privacidade" style={{ color: 'var(--nc-primary)', textDecoration: 'none' }} onClick={e => { e.preventDefault(); navigate('/privacidade'); }}>• Política de Privacidade</a>
            <a href="/termos" style={{ color: 'var(--nc-primary)', textDecoration: 'none' }} onClick={e => { e.preventDefault(); navigate('/termos'); }}>• Termos de Uso</a>
            <a href="/lgpd" style={{ color: 'var(--nc-primary)', textDecoration: 'none' }} onClick={e => { e.preventDefault(); navigate('/lgpd'); }}>• Seus direitos (LGPD)</a>
            <a href="/contato" style={{ color: 'var(--nc-primary)', textDecoration: 'none' }} onClick={e => { e.preventDefault(); navigate('/contato'); }}>• Contato e suporte</a>
          </div>
        </div>
      </div>
    </div>
  );
}
